import { render, staticRenderFns } from "./BaseFormTextarea.vue?vue&type=template&id=8cc64bb4&scoped=true"
import script from "./BaseFormTextarea.vue?vue&type=script&lang=js"
export * from "./BaseFormTextarea.vue?vue&type=script&lang=js"
import style0 from "./BaseFormTextarea.vue?vue&type=style&index=0&id=8cc64bb4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc64bb4",
  null
  
)

export default component.exports